import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import {
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { date } from '../../utils/parsing';
import ExportsLoader from '../loaders/ExportsLoader';
import BuildingsLoader from '../loaders/BuildingsLoader';

/**
 * A table of previously defined timeseries exports
 */
const ExportsTable = ({ tsExports, loaded, buildingsById }) => {
  let inner;
  if (!loaded) {
    inner = <LinearProgress color="secondary" style={{ width: '400px' }} />;
  } else if (tsExports.length === 0) {
    inner = <Typography variant="h5">You haven&apos;t created an export yet</Typography>;
  } else {
    inner = (
      <Table>
        <BuildingsLoader />
        <TableHead className="header">
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Description</TableCell>
            <TableCell>Sites</TableCell>
            <TableCell>Time Range</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {tsExports.map(({ id, name, description, query }) => (
            <TableRow key={id}>
              <TableCell>
                <Link to={`/exports/edit/${id}`}>{name || '(unnamed)'}</Link>
              </TableCell>
              <TableCell>{description}</TableCell>
              <TableCell>
                {query.selector.buildings.length > 1 ? (
                  `${query.selector.buildings.length} Sites`
                ) : (
                  <Link to={`/explore/buildings/b?bid=${query.selector.buildings[0]}`}>
                    {buildingsById[query.selector.buildings[0]]?.name || '1 Site'}
                  </Link>
                )}
              </TableCell>
              <TableCell>
                {date(query.start)} - {date(query.end)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    );
  }
  return (
    <>
      <ExportsLoader />
      {inner}
    </>
  );
};

export default connect(
  ({
    entities: {
      tsExports: { loaded, byId },
      buildings: { byId: buildingsById },
    },
  }) => ({
    loaded,
    tsExports: Object.values(byId),
    buildingsById,
  })
)(ExportsTable);
